<template>
  <base-page
    v-bind:schemaName="'product'"
    v-bind:isHideRemove="true"
    v-model:entity="entity"
    v-on:saved="onSaved"
  >
    <template v-slot:panel-left="{ entity }">
      <div class="mb-3 text-center">
        <img
          v-bind:src="
            entity.image ?? require('@/assets/not-pictured-large.png')
          "
          class="img-thumbnail rounded mb-2 image-size"
        />
        <input
          type="url"
          id="image"
          class="form-control mb-2"
          v-model="entity.image"
        />
      </div>
      <div class="mb-3 text-left">
        <label class="form-label">{{
          $filters.localize("ProductPage.fields.name")
        }}</label>
        <input type="text" class="form-control" v-model="entity.name" />
      </div>
      <div class="mb-3 text-left">
        <label class="form-label">{{
          $filters.localize("ProductPage.fields.wholeSalePrice")
        }}</label>
        <input
          min="0"
          type="number"
          class="form-control"
          v-model="entity.wholeSalePrice"
        />
      </div>
      <div class="mb-3 text-left">
        <label class="form-label">{{
          $filters.localize("ProductPage.fields.price")
        }}</label>
        <input type="number" class="form-control" v-model="entity.price" />
      </div>
      <div class="mb-3 text-left">
        <label class="form-label">{{
          $filters.localize("ProductPage.fields.purchasePrice")
        }}</label>
        <input
          type="number"
          class="form-control"
          v-model="entity.purchasePrice"
        />
      </div>
      <div class="mb-3 text-left">
        <label class="form-label">{{
          $filters.localize("ProductPage.fields.code")
        }}</label>
        <input
          type="text"
          class="form-control"
          v-model="entity.code"
          required
        />
      </div>
      <div class="mb-3 text-left">
        <label class="form-label">{{
          $filters.localize("ProductPage.fields.category")
        }}</label>
        <select
          :disabled="categories.length === 0"
          class="form-control"
          v-model="entity.categoryId"
        >
          <option
            v-for="option in categories"
            v-bind:key="option.id"
            :value="option.id"
          >
            {{ option.name }}
          </option>
        </select>
      </div>
      <div class="mb-3 text-left">
        <div>
          <label class="form-label"
            >{{ $filters.localize("ProductPage.fields.isPromotion") }}:</label
          >
        </div>
        <input type="checkbox" v-model="entity.isPromotion" />
        <label class="form-label"
          >&nbsp; {{ entity.isPromotion ? "Так" : "Ні" }}
        </label>
      </div>
      <div class="mb-3 text-left">
        <div>
          <label class="form-label"
            >{{ $filters.localize("ProductPage.fields.isTailoringAvailable") }}:</label
          >
        </div>
        <input type="checkbox" v-model="entity.isTailoringAvailable" />
        <label class="form-label"
          >&nbsp; {{ entity.isTailoringAvailable ? "Так" : "Ні" }}
        </label>
      </div>
      <div
        v-if="entity.isTailoringAvailable"
        class="mb-3 text-left"
      >
        <label class="form-label">{{
          $filters.localize("ProductPage.fields.tailoringTerm")
        }}</label>
        <select
          :disabled="tailoringTerms.length === 0"
          class="form-control"
          v-model="entity.tailoringTermId"
        >
          <option :value="null"></option>
          <option
            v-for="option in tailoringTerms"
            v-bind:key="option.id"
            :value="option.id"
          >
            {{ option.name }}
          </option>
        </select>
      </div>
    </template>

    <template v-slot:header="{ entity }">
      <div class="mb-3 text-left">
        <label class="form-label">{{
          $filters.localize("ProductPage.fields.description")
        }}</label>
        <textarea class="form-control" v-model="entity.description" />
      </div>
      <div class="mb-3 text-left">
        <label class="form-label">{{
          $filters.localize("ProductPage.fields.comment")
        }}</label>
        <textarea class="form-control" v-model="entity.comment" />
      </div>
      <div class="mb-3 text-left">
        <label class="form-label">{{
          $filters.localize("ProductPage.fields.gridSize")
        }}</label>
        <textarea class="form-control" v-model="entity.dimensionalGrid" />
      </div>
    </template>

    <template v-slot:body="{ entity, action, save }">
      <product-remains-detail
        ref="productRemainsDetail"
        v-bind:rootId="entity.id || this.$route.params.id"
        v-bind:rootColumn="'ProductId'"
        v-bind:enabled="action == 'update'"
        v-bind:productIsTailoringAvailable="entity.isTailoringAvailable"
        v-on:main-save="save"
      ></product-remains-detail>
    </template>
  </base-page>
</template>

<script>
import ProductRemainsDetail from "@/views/details/remains/ProductRemainsDetail.vue";
import BasePage from "@/components/Sections/BasePage.vue";
export default {
  name: "ProductPage",
  components: { BasePage, ProductRemainsDetail },
  data() {
    return {
      categories: [],
      tailoringTerms: [],
      entity: {},
    };
  },
  watch: {
    "entity.isTailoringAvailable"(value) {
      if (!value) {
        this.entity.tailoringTermId = null;
      }
    },
  },
  methods: {
    loadLookups() {
      this.$store
        .dispatch("section", { table: "productcategory" })
        .then((response) => {
          this.categories = response.data.data;
        });
      this.$store
        .dispatch("section", { table: "tailoringterm" })
        .then((response) => {
          this.tailoringTerms = response.data.data;
        });
    },
    onSaved(entity) {
      if (entity?.isTailoringAvailable) return;

      this.$refs.productRemainsDetail?.disableTailoringAvailability();
      this.entity.tailoringTermId = null;
    },
  },
  mounted() {
    this.loadLookups();
  },
};
</script>
<style scoped>
.image-size {
  max-height: 300px;
  width: 300px;
}
</style>
